import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { stringToPointNumber } from "MainPages/Utils/decimal.utils";
import dayjs from "dayjs";
import {
  useFormattedUserListOption,
  useFormattedVehicleCategoryOption,
  useFormattedVehicleTypeOption,
} from "core/Operations/formattedOption/useFormattedMasterOptions";
import PropTypes from "prop-types";
import InputWarningMessage from "Components/UI/InputWarningMessage";

const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "Inactive", value: false },
];

const isStatusOption2 = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const projectStatusOptions = [
  { label: "Pending", value: "Pending" },
  { label: "Processing", value: "Processing" },
  { label: "Completed", value: "Completed" },
];

const ApprovalInfo = ({ userData }) => {
  const {
    watch,
    setValue,
    trigger,
    register,
    formState: { errors },
  } = useFormContext();

  const approvedByOptions = useFormattedUserListOption({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });
  // console.log("approvedByOptions", approvedByOptions);
  const index = 0;
  return (
    <>
      <div className="form-row row">
        <h4 className="header-title">Approval Information</h4>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.clientWORefNo`}
            type="text"
            placeholder="Client WO RefNo"
            className={`form-control ${
              errors?.approvalDetails?.clientWORefNo ? "is-invalid" : ""
            }`}
            label="Client WO RefNo"
            labelClassName="form-label"
            required={false}
            requiredMessage="Client WO RefNo is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.clientContractNo`}
            type="text"
            placeholder="Client Contract No"
            className={`form-control ${
              errors?.approvalDetails?.clientContractNo ? "is-invalid" : ""
            }`}
            label="Client Contract No"
            labelClassName="form-label"
            required={false}
            requiredMessage="Client Contract No is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.workOrderMode`}
            type="text"
            placeholder="Work Order Mode"
            className={`form-control ${
              errors?.approvalDetails?.workOrderMode ? "is-invalid" : ""
            }`}
            label="Work Order Mode"
            labelClassName="form-label"
            required={false}
            requiredMessage="Work Order Mode is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name={`approvalDetails.hardcopyReceived`}
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors?.approvalDetails?.hardcopyReceived ? "is-invalid" : ""
            }`}
            label="Hard Copy Received"
            labelClassName="form-label"
            optionData={isStatusOption}
            required={false}
            requiredMessage="Hard Copy Received is required"
            onChange={(selectedOption) => {
              setValue("hardcopyReceived", selectedOption);
              trigger("hardcopyReceived");
            }}
            defaultValue={watch("hardcopyReceived")}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.remarks`}
            type="text"
            placeholder="Remarks"
            className={`form-control ${
              errors?.approvalDetails?.remarks ? "is-invalid" : ""
            }`}
            label="Remarks"
            labelClassName="form-label"
            required={false}
            requiredMessage="Remarks is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.technicalDetails`}
            type="text"
            placeholder="Technical Details"
            className={`form-control ${
              errors?.approvalDetails?.technicalDetails ? "is-invalid" : ""
            }`}
            label="Technical Details"
            labelClassName="form-label"
            required={false}
            requiredMessage="Technical Details is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.latitude`}
            type="text"
            placeholder="Latitude"
            className={`form-control ${
              errors?.approvalDetails?.latitude ? "is-invalid" : ""
            }`}
            label="Latitude"
            labelClassName="form-label"
            required={false}
            requiredMessage="Latitude is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.longitude`}
            type="text"
            placeholder="Longitude"
            className={`form-control ${
              errors?.approvalDetails?.longitude ? "is-invalid" : ""
            }`}
            label="Longitude"
            labelClassName="form-label"
            required={false}
            requiredMessage="Longitude is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.commercialDetails`}
            type="text"
            placeholder="Commercial Details"
            className={`form-control ${
              errors?.approvalDetails?.commercialDetails ? "is-invalid" : ""
            }`}
            label="Commercial Details"
            labelClassName="form-label"
            required={false}
            requiredMessage="Commercial Details is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.minimumManday`}
            type="text"
            placeholder="Minimum Manday"
            className={`form-control ${
              errors?.approvalDetails?.minimumManday ? "is-invalid" : ""
            }`}
            label="Minimum Manday"
            labelClassName="form-label"
            required={false}
            requiredMessage="Minimum Manday is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.estimatedManHours`}
            type="text"
            placeholder="Estimated Man Hours"
            className={`form-control ${
              errors?.approvalDetails?.estimatedManHours ? "is-invalid" : ""
            }`}
            label="Estimated Man Hours"
            labelClassName="form-label"
            required={false}
            requiredMessage="Estimated Man Hours is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.estimatedManHourCost`}
            type="text"
            placeholder="Estimated Man Hour Cost"
            className={`form-control ${
              errors?.approvalDetails?.estimatedManHourCost ? "is-invalid" : ""
            }`}
            label="Estimated Man Hour Cost"
            labelClassName="form-label"
            required={false}
            requiredMessage="Estimated Man Hour Cost is required"
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.estimatedMaterialCost`}
            type="text"
            placeholder="Estimated Material Cost"
            className={`form-control ${
              errors?.approvalDetails?.estimatedMaterialCost ? "is-invalid" : ""
            }`}
            label="Estimated Material Cost"
            labelClassName="form-label"
            required={false}
            requiredMessage="Estimated Material Cost is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.isLoginAllLocations`}
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors?.approvalDetails?.isActive ? "is-invalid" : ""
            }`}
            label="Allow Login All Locations"
            labelClassName="form-label"
            optionData={isStatusOption2}
            required={true}
            requiredMessage="Allow Login is required"
            onChange={(selectedOption) => {
              console.log("selectedOption", selectedOption);
              setValue(`approvalDetails.isLoginAllLocations`, selectedOption);
              trigger(`approvalDetails.isLoginAllLocations`);
              trigger(`approvalDetails.locationRadius`);
            }}
            defaultValue={watch(`approvalDetails.isLoginAllLocations`)}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.locationRadius`}
            type="text"
            placeholder="Location Radius"
            className={`form-control ${
              errors?.approvalDetails?.locationRadius ? "is-invalid" : ""
            }`}
            label="Location Radius"
            labelClassName="form-label"
            required={!watch(`approvalDetails.isLoginAllLocations`)}
            requiredMessage="Location Radius is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`approvalDetails.isActive`}
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors?.approvalDetails?.isActive ? "is-invalid" : ""
            }`}
            label="Active Status"
            labelClassName="form-label"
            optionData={isStatusOption}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue(`approvalDetails.isActive`, selectedOption?.value);
              trigger(`approvalDetails.isActive`);
            }}
            defaultValue={watch(`approvalDetails.isActive`)}
          />
        </div>
      </div>
      <InputWarningMessage
        message="*All mandatory fields to be entered to Save the record."
        type="danger"
      />
    </>
  );
};
ApprovalInfo.propTypes = {
  userData: PropTypes.any.isRequired,
};
export default React.memo(ApprovalInfo);
